import ModalRightSideBarTemplate from "../../../../../../../App/views/ModalRightSideBarTemplate";
import React, { useContext, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  isModalMeetingRoomUpdateSelector,
  meetingRoomDetailSelector,
  propertyDetailSelector,
} from "../../../../../../selectors/PropertySelector";
import { modalMeetingRoomUpdateAction } from "../../../../../../actions/PropertyActions";
import { Formik } from "formik";
import * as yup from "yup";
import { Modal, TextArea } from "semantic-ui-react";
import SizeBox from "../../../../../../../../components/SizeBox";
import Label from "../../../../../../../../components/Label";
import ButtonCustom from "../../../../../../../../components/Button";
import { LocalizationContext } from "../../../../../../../../locales/Translation";
import { PUBLIC_URL } from "../../../../../../../App/configs/Constants";
import InputCustom from "../../../../../../../../components/Input";
import Divide from "../../../../../../../../components/Divide";
import DropzoneComponent from "../../../DetailsTab/Components/DropzoneComponent";
import AmenityItemSelect from "../../../../../../../../components/AmenityItemSelect";
import { useParams } from "react-router-dom";
import { updateMeetingRoomService } from "../../../../../../services/PropertyServices";
import { getMeetingRoomThunk } from "../../../../../../thunks/PropertyThunks";
import {
  toastError,
  toastSuccess,
} from "../../../../../../../../components/Toast";
import {
  ROLE_DESKIMO_ADMIN_ID,
  ROLE_PROPERTY_ADMIN_ID,
} from "../../../../../../../User/configs/Constants";
import {
  MyProfileType,
  UserCompanyType,
} from "../../../../../../../User/configs/DeclareTypes";
import { myProfileSelector } from "../../../../../../../App/selectors/AppSelectors";
import DropdownCustom from "../../../../../../../../components/DropdownCustom";
import { MINIMUM_BOOKING_TIME } from "../../../../../../configs/Constants";
import { userCompanyChooseSelector } from "../../../../../../../User/selectors/UserSelectors";
import MeetingRoomSchedule, {
  getMeetingRoomScheduleInitValues,
  getMeetingRoomSchedulePayload,
  meetingRoomScheduleValidation,
} from "../MeetingRoomSchedule";

const ModalUpdateMeetingRoom = ({ meetingRoomFilter }: any) => {
  const [loading, setLoading] = useState(false);
  const { translations } = useContext(LocalizationContext);
  const dispatch = useDispatch();
  const isModalMeetingRoomUpdate = useSelector(
    isModalMeetingRoomUpdateSelector
  );
  const meetingRoomDetail = useSelector(meetingRoomDetailSelector);
  const propertyDetail = useSelector(propertyDetailSelector);
  const { id } = useParams();
  const [amenities, setAmenities] = useState<any>([]);
  const myProfile: MyProfileType = useSelector(myProfileSelector);
  const userCompanyChoose: UserCompanyType = useSelector(
    userCompanyChooseSelector
  );
  const options = MINIMUM_BOOKING_TIME();

  const _handleSave = async ({
    use_property_hours,
    schedule_week_days,
    ...values
  }: any) => {
    const payload = {
      ...values,
      schedule: getMeetingRoomSchedulePayload(
        use_property_hours,
        schedule_week_days
      ),
      property_id: id,
      meeting_room_id: meetingRoomDetail?.id,
      amenities: amenities,
    };
    setLoading(true);
    try {
      await updateMeetingRoomService(payload);
      dispatch(modalMeetingRoomUpdateAction(false));
      const filters = {
        ...meetingRoomFilter,
        page: 1,
        keyword: "",
        statuses: [0, 1],
        property_id: id,
      };
      await dispatch<any>(getMeetingRoomThunk(filters));
      toastSuccess("Successfully updated meeting room");
    } catch (response: any) {
      toastError(response?.status?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setAmenities(meetingRoomDetail?.amenities);
  }, [meetingRoomDetail]);

  return (
    <ModalRightSideBarTemplate
      trigger={null}
      onClose={() => dispatch(modalMeetingRoomUpdateAction(false))}
      modalClassName={"modal-edit-employee"}
      open={isModalMeetingRoomUpdate}
    >
      <Formik
        enableReinitialize
        initialValues={{
          name: meetingRoomDetail?.name || "",
          hourly_rate: meetingRoomDetail?.hourly_rate || "",
          daily_rate: meetingRoomDetail?.daily_rate || "",
          booking_requirement: meetingRoomDetail?.booking_requirement
            ? meetingRoomDetail?.booking_requirement
            : "",
          capacity: meetingRoomDetail?.capacity || "",
          images: meetingRoomDetail?.images ? meetingRoomDetail?.images : [],
          amenities: meetingRoomDetail?.amenities
            ? meetingRoomDetail?.amenities
            : [],
          position_guide: meetingRoomDetail?.position_guide || "",
          minimum_booking_time: meetingRoomDetail?.minimum_booking_time || 0,
          ...getMeetingRoomScheduleInitValues(
            meetingRoomDetail?.schedule,
            propertyDetail?.schedule
          ),
        }}
        validationSchema={yup.object().shape({
          name: yup.string().required().label("Meeting Room Name"),
          schedule_week_days: meetingRoomScheduleValidation(yup),
        })}
        onSubmit={_handleSave}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <>
            <Modal.Header>
              <div>{"Edit Meeting Room"}</div>
              <ButtonCustom
                onClick={() => dispatch(modalMeetingRoomUpdateAction(false))}
                className={"m-0 p-0 none-bg close-modal"}
              >
                <>
                  {translations.settings.close}
                  <img src={PUBLIC_URL + "/assets/icons/icon-close-grey.svg"} />
                </>
              </ButtonCustom>
            </Modal.Header>
            <Modal.Content className={"scroll"}>
              <InputCustom
                label={"Meeting Room Name"}
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched.name}
                error={errors.name}
                name={"name"}
              />
              <div className={"mb-16px"} />
              <Label
                fontSize={"12px"}
                labelGuide={
                  "Add 1-2 sentences with information about the location of the meeting room for visitors to find it more easily once they arrive at your workspace."
                }
                label={"Meeting Room Location"}
                className={"sm"}
              />
              <TextArea
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched.position_guide}
                error={errors.position_guide}
                name={"position_guide"}
                className={"text-area"}
                rows={6}
                value={values.position_guide}
              />
              <div className={"mb-16px"} />

              <div className={"form-row"}>
                <InputCustom
                  label={translations.hourlyRate}
                  value={values.hourly_rate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.hourly_rate}
                  error={errors.hourly_rate}
                  name={"hourly_rate"}
                  inputLeftIcon={meetingRoomDetail?.currency}
                  inputLeftIconBorder
                  disabled={
                    myProfile?.role_id === ROLE_DESKIMO_ADMIN_ID &&
                    !Object.keys(userCompanyChoose).length
                      ? false
                      : !(
                          myProfile?.role_id !== ROLE_DESKIMO_ADMIN_ID &&
                          Object.keys(userCompanyChoose).length &&
                          userCompanyChoose?.role_id === ROLE_PROPERTY_ADMIN_ID
                        )
                  }
                  removeLetter
                />
                <InputCustom
                  label={translations.dailyRateFullDay}
                  value={values.daily_rate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.daily_rate}
                  error={errors.daily_rate}
                  name={"daily_rate"}
                  inputLeftIcon={meetingRoomDetail?.currency}
                  inputLeftIconBorder
                  disabled={
                    myProfile?.role_id === ROLE_DESKIMO_ADMIN_ID &&
                    !Object.keys(userCompanyChoose).length
                      ? false
                      : !(
                          myProfile?.role_id !== ROLE_DESKIMO_ADMIN_ID &&
                          Object.keys(userCompanyChoose).length &&
                          userCompanyChoose?.role_id === ROLE_PROPERTY_ADMIN_ID
                        )
                  }
                  removeLetter
                />
              </div>
              <div className={"form-row"}>
                <InputCustom
                  label={translations.capacity}
                  value={values.capacity}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.capacity}
                  error={errors.capacity}
                  name={"capacity"}
                  inputLeftIcon={"People"}
                  inputLeftIconBorder
                  removeLetter
                />
                {myProfile?.role_id === ROLE_DESKIMO_ADMIN_ID ? (
                  <div>
                    <Label
                      fontSize={"12px"}
                      label={"Minimum Booking Time"}
                      className={"sm"}
                    />
                    <DropdownCustom
                      onChange={(e: any, data: any) => {
                        setFieldValue("minimum_booking_time", data.value);
                      }}
                      scrolling
                      selectUI
                      className={"w-100"}
                      pointing
                      value={values.minimum_booking_time}
                      options={options}
                    />
                  </div>
                ) : (
                  <SizeBox width={"0px"} height={"17px"} />
                )}
              </div>
              <MeetingRoomSchedule
                usePropertyHours={values.use_property_hours}
                weekDays={values.schedule_week_days}
                setFieldValue={setFieldValue}
                error={errors.schedule_week_days}
              />
              <div className={"mb-16px"} />
              <Label
                fontSize={"12px"}
                label={"Booking Requirements"}
                className={"sm"}
              />
              <TextArea
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched.booking_requirement}
                error={errors.booking_requirement}
                name={"booking_requirement"}
                className={"text-area"}
                rows={6}
                value={values.booking_requirement}
              />

              <div className={"mb-16px"} />
              <Divide type={"horizontal"} />
              <SizeBox height={"21px"} />
              <Label fontSize={"12px"} label={"Photos"} className={"sm"} />
              <DropzoneComponent
                onDragEnd={(
                  sourceId: any,
                  sourceIndex: any,
                  targetIndex: any
                ) => {
                  if (sourceIndex === targetIndex) return;

                  if (values.images) {
                    let newState = JSON.parse(JSON.stringify(values.images));
                    const sourceItem = newState[sourceIndex];

                    newState = newState.filter(
                      (image: any) => image.id !== sourceItem.id
                    );

                    if (sourceItem) {
                      newState.splice(targetIndex, 0, sourceItem);

                      newState.forEach((item: any, index: number) => {
                        item.weight = index;
                      });

                      setFieldValue("images", newState);
                    }
                  }
                }}
                isDragDropChangeOrder={true}
                value={values.images}
                deletePhotos={(id: any) => {
                  const newImages = values.images.filter(
                    (image: any) => image?.id !== id
                  );
                  setFieldValue("images", newImages);
                }}
                setPhotos={(data: any) =>
                  setFieldValue("images", [...values.images, ...data])
                }
              />
              <Divide type={"horizontal"} />
              <SizeBox height={"16px"} />
              <div>
                {amenities?.length > 0
                  ? amenities.map((amenity: any) => {
                      return (
                        <AmenityItemSelect
                          item={amenity}
                          key={amenity?.id}
                          onChangeCheck={(id: any) => {
                            const newState = amenities.map((item: any) => {
                              if (parseInt(item.id) === parseInt(id)) {
                                return { ...item, is_chosen: !item.is_chosen };
                              }

                              return item;
                            });
                            setAmenities(newState);
                          }}
                          onChangeFree={(id: any) => {
                            const newState = amenities.map((item: any) => {
                              if (parseInt(item.id) === parseInt(id)) {
                                return { ...item, is_free: !item.is_free };
                              }

                              return item;
                            });
                            setAmenities(newState);
                          }}
                        />
                      );
                    })
                  : null}
              </div>
            </Modal.Content>
            <Modal.Actions>
              <ButtonCustom
                height={"47px"}
                onClick={() => dispatch(modalMeetingRoomUpdateAction(false))}
              >
                {translations.settings.cancel}
              </ButtonCustom>
              <ButtonCustom
                loading={loading}
                type={"submit"}
                className={"primary"}
                height={"47px"}
                onClick={handleSubmit}
              >
                {translations.settings.save}
              </ButtonCustom>
            </Modal.Actions>
          </>
        )}
      </Formik>
    </ModalRightSideBarTemplate>
  );
};

export default ModalUpdateMeetingRoom;
